import React, { useEffect } from 'react';
import Navbar from '../../components/common/Navbar';
import Footer from '../../components/common/Footer';
import AboutHero from './AboutHero';
import AboutStory from './AboutStory';
import AboutValues from './AboutValues';
import AboutFeatures from './AboutFeatures';
import AboutTeam from './AboutTeam';
import AboutFAQ from './AboutFAQ';
import AboutCTA from './AboutCTA';
import LogoPatternBackground from '../../components/common/LogoPatternBackground';

const AboutPage = () => {
  // Sayfaya smooth scroll efekti ekle
  useEffect(() => {
    // Sayfa yüklendiğinde yukarıdan başla
    window.scrollTo(0, 0);
    
    // Smooth scroll için CSS değişkeni ekle
    document.documentElement.style.scrollBehavior = 'smooth';
    
    // Page load animasyonu
    document.body.classList.add('page-loaded');
    
    return () => {
      // Component unmount olduğunda temizle
      document.documentElement.style.scrollBehavior = '';
      document.body.classList.remove('page-loaded');
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50 relative">
      {/* Sayfa yükleniyor animasyonu */}
      <div className="page-loading fixed inset-0 flex items-center justify-center bg-indigo-600 z-50">
        <div className="loading-logo text-white text-4xl font-bold flex items-center">
          <span className="animate-pulse mr-2">♪</span>
          <span>İYTE</span>
          <span className="animate-pulse mx-2">♫</span>
          <span>Müzik</span>
        </div>
      </div>
      <div className="fixed inset-0 z-0">
        <LogoPatternBackground opacity={0.1} size={100} animate={true} />
      </div>
      
      <Navbar />
      <AboutHero />
      
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 -mt-12 relative z-10">
        <div className="bg-white shadow-xl rounded-xl overflow-hidden transition-all duration-500 hover:shadow-2xl">
          <AboutStory />
          <AboutValues />
          <AboutFeatures />
          <AboutTeam />
          <AboutFAQ />
        </div>
      </div>
      
      <AboutCTA />
      <Footer />
      
      {/* Müzik notaları süslemesi */}
      <div className="floating-notes fixed inset-0 pointer-events-none z-0 opacity-10">
        {Array(10).fill().map((_, i) => (
          <div 
            key={i}
            className="absolute text-indigo-600 opacity-50"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              fontSize: `${Math.random() * 20 + 10}px`,
              animation: `float ${Math.random() * 10 + 20}s linear ${Math.random() * 10}s infinite`
            }}
          >
            {['♪', '♫', '♬', '♩'][Math.floor(Math.random() * 4)]}
          </div>
        ))}
      </div>
      
      {/* Sayfaya özgü stiller */}
      <style jsx>{`
        /* Sayfa yükleniyor animasyonu */
        .page-loaded .page-loading {
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.6s ease, visibility 0.6s;
        }
        
        .page-loading {
          transition: opacity 0.6s ease, visibility 0.6s;
        }
        
        .loading-logo span {
          display: inline-block;
        }
        
        /* Floating notes animasyonu */
        @keyframes float {
          0% {
            transform: translate(0, 0) rotate(0deg);
          }
          25% {
            transform: translate(20px, 20px) rotate(10deg);
          }
          50% {
            transform: translate(0, 40px) rotate(0deg);
          }
          75% {
            transform: translate(-20px, 20px) rotate(-10deg);
          }
          100% {
            transform: translate(0, 0) rotate(0deg);
          }
        }
      `}</style>
    </div>
  );
};

export default AboutPage;